import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  dataInRequest,
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/distribuidora/actions';

import Form from './form';

function Distribuidora() {
  const redux = useSelector((state) => state.distribuidora);

  const header = useMemo(
    () => [
      {
        id: 'cnpjdistribuidoranfe',
        label: t('s.configuracao.posto.cnpjposto'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'nomedistribuidoranfe',
        label: t('s.configuracao.posto.nomedistribuidoraposto'),
        filter: {
          type: 'text',
        },
      },
    ],
    []
  );

  const fieldlist = ['cnpjdistribuidoranfe', 'nomedistribuidoranfe'];

  const substituirHeader = {
    cnpjdistribuidoranfe: t('s.configuracao.posto.cnpjposto'),
    nomedistribuidoranfe: t('s.configuracao.posto.nomedistribuidoraposto'),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      remove={deleteData}
      form={Form}
      keys="cnpjdistribuidoranfe"
      detach="cnpjdistribuidoranfe"
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'distribuidorasnfes',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatorio de Distribuidoras',
        })
      }
    />
  );
}

export default Distribuidora;
